import m from "../../geodata/es2015/botswanaLow";
window.am4geodata_botswanaLow = m;


//////////////////
// WEBPACK FOOTER
// ./geodata/botswanaLow.js
// module id = null
// module chunks = 